import { tsUtils } from '@neo-one/ts-utils';
import { utils } from '@neo-one/utils';
import ts from 'typescript';
import { NodeCompiler } from '../NodeCompiler';
export class PrefixUnaryExpressionCompiler extends NodeCompiler {
    constructor() {
        super(...arguments);
        this.kind = ts.SyntaxKind.PrefixUnaryExpression;
    }
    visitNode(sb, expr, options) {
        const token = tsUtils.expression.getOperator(expr);
        switch (token) {
            case ts.SyntaxKind.PlusPlusToken:
            case ts.SyntaxKind.MinusMinusToken:
                this.visitAssignment(sb, token, expr, options);
                break;
            case ts.SyntaxKind.PlusToken:
            case ts.SyntaxKind.MinusToken:
            case ts.SyntaxKind.TildeToken:
            case ts.SyntaxKind.ExclamationToken:
                this.visitValue(sb, token, expr, options);
                break;
            default:
                utils.assertNever(token);
        }
    }
    visitAssignment(sb, token, expr, options) {
        sb.visit(tsUtils.expression.getOperand(expr), sb.noSetValueOptions(sb.pushValueOptions(options)));
        switch (token) {
            case ts.SyntaxKind.PlusPlusToken:
                sb.emitHelper(expr, sb.pushValueOptions(options), sb.helpers.toNumber({ type: sb.context.analysis.getType(expr) }));
                sb.emitOp(expr, 'INC');
                sb.emitHelper(expr, sb.pushValueOptions(options), sb.helpers.wrapNumber);
                break;
            case ts.SyntaxKind.MinusMinusToken:
                sb.emitHelper(expr, sb.pushValueOptions(options), sb.helpers.toNumber({ type: sb.context.analysis.getType(expr) }));
                sb.emitOp(expr, 'DEC');
                sb.emitHelper(expr, sb.pushValueOptions(options), sb.helpers.wrapNumber);
                break;
            default:
                utils.assertNever(token);
        }
        sb.visit(tsUtils.expression.getOperand(expr), sb.setValueOptions(options));
    }
    visitValue(sb, token, expr, optionsIn) {
        const options = sb.pushValueOptions(optionsIn);
        const operand = tsUtils.expression.getOperand(expr);
        sb.visit(operand, sb.noSetValueOptions(options));
        switch (token) {
            case ts.SyntaxKind.PlusToken:
                sb.emitHelper(expr, options, sb.helpers.toNumber({ type: sb.context.analysis.getType(operand) }));
                sb.emitHelper(expr, options, sb.helpers.wrapNumber);
                break;
            case ts.SyntaxKind.MinusToken:
                sb.emitHelper(expr, options, sb.helpers.toNumber({ type: sb.context.analysis.getType(operand) }));
                sb.emitOp(expr, 'NEGATE');
                sb.emitHelper(expr, options, sb.helpers.wrapNumber);
                break;
            case ts.SyntaxKind.TildeToken:
                sb.emitHelper(expr, options, sb.helpers.toNumber({ type: sb.context.analysis.getType(operand) }));
                sb.emitOp(expr, 'INVERT');
                sb.emitHelper(expr, options, sb.helpers.wrapNumber);
                break;
            case ts.SyntaxKind.ExclamationToken:
                sb.emitHelper(operand, options, sb.helpers.toBoolean({ type: sb.context.analysis.getType(operand) }));
                sb.emitOp(expr, 'NOT');
                sb.emitHelper(operand, options, sb.helpers.wrapBoolean);
                break;
            default:
                utils.assertNever(token);
        }
        if (!optionsIn.pushValue) {
            sb.emitOp(expr, 'DROP');
            return;
        }
    }
}

//# sourceMappingURL=PrefixUnaryExpressionCompiler.js.map
